import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    TextField,
    FormControl,
    Button,
    Box,
    Card,
    CardContent,
    Dialog,DialogActions,DialogContent,DialogTitle,
    IconButton,
    CircularProgress
} from "@mui/material";
import { useForm } from "react-hook-form";
import { IconAlertTriangle, IconX } from "@tabler/icons-react";
import PageContainer from "../MainPages/PageContainer";
import Breadcrumb from "../MainPages/Breadcrumb";

const CardDetails = () => {
    const { register, handleSubmit, setValue, trigger, formState: { errors } } = useForm();
    const [isEditing, setIsEditing] = useState(false); 
    const [subid, setsubid] = useState('')
    const [Errorpopup,setErrorpopup]= useState(false)
    const [errorMessage,seterrorMessage]= useState('')
    const userInfo=JSON.parse(sessionStorage.getItem('user-info'))
    const [loader,setloader]=useState(false)
    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setloader(true)
        try {
            const response = await axios.get(`/apiV1/get-card-details/?user_id=${userInfo.id}`);
            if (response.status === 200) {
                setValue("cardNumber", response.data.card_number);
                setsubid(response.data.subscription_id)
                setloader(false)

            }
        } catch (err) {
            console.log(err);
            setloader(false)
            
        }
    };

    const onSubmit = async (data) => {
        setloader(true)
        try {
            let req = {
                sub_id: subid,
                card_number: data.cardNumber,
                expiry: data.expiryDate,
                card_code: data.cvv
            }
            const response = await axios.post('/apiV1/update-card-details/', req)
            if (response.status == 200) {
                setloader(false)
                setIsEditing(false);

            }
        } catch (err) {
            console.log(err);
            setErrorpopup(true)
            seterrorMessage(err.response.data.message)
            setloader(false)
            setIsEditing(false)

        }
    };
    const BCrumb = [
        {
          to: '/plans',
          title: 'Plans',
        }
      ];
    return (
        <PageContainer title="AutoSDLC | Card Details">
        <Breadcrumb breadcrumbs={BCrumb} />
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Card sx={{ width: "100%", maxWidth: 500, padding: 3, boxShadow: 3 }}>
                    <CardContent>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                            Card Details
                        </Typography>

                        <form onSubmit={isEditing ? handleSubmit(onSubmit) : (e) => e.preventDefault()}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            Card Number
                                        </Typography>
                                        <TextField
                                            placeholder="Card Number"
                                            {...register("cardNumber", {
                                                required: "Card number is required",
                                                pattern: {
                                                    value: /^\d{16}$/,
                                                    message: "Card number must be 16 digits"
                                                }
                                            })}
                                            error={!!errors.cardNumber}
                                            helperText={errors.cardNumber?.message}
                                            onKeyUp={() => trigger("cardNumber")}
                                            disabled={!isEditing || loader}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            Expiry Date
                                        </Typography>
                                        <TextField
                                             placeholder="YYYY-MM"
                                            {...register("expiryDate", {
                                                required: "Expiry date is required",
                                                pattern: {
                                                    value: /^\d{4}-(0[1-9]|1[0-2])$/,
                                                    message: "Invalid format (YYYY-MM)"
                                                }
                                            })}
                                            onKeyUp={() => trigger("expiryDate")}
                                            error={!!errors.expiryDate}
                                            helperText={errors.expiryDate?.message}
                                            disabled={!isEditing || loader}

                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            CVV
                                        </Typography>
                                        <TextField
                                            placeholder="CVV"
                                            {...register("cvv", {
                                                required: "CVV is required",
                                                pattern: {
                                                    value: /^[0-9]{3,4}$/,
                                                    message: "CVV must be 3 or 4 digits"
                                                }
                                            })}
                                            error={!!errors.cvv}
                                            helperText={errors.cvv?.message}
                                            onKeyUp={() => trigger("cvv")}
                                            disabled={!isEditing || loader}

                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {isEditing ?
                                <Button type="submit" variant="contained" className="button2" sx={{ mt: 2 }} disabled={loader}>
                                   {loader ? <CircularProgress size={20}/> : "Save"} 
                                </Button> : ""}
                        </form>
                        {!isEditing ? <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setIsEditing(true)}
                            sx={{ mt: 2 }} disabled={loader}>
                            Edit
                        </Button> : ""}
                    </CardContent>
                </Card>
            </Box>
            <Dialog
                        open={Errorpopup}
                        onClose={()=>setErrorpopup(false)}
                        aria-labelledby="error-dialog-title"
                        aria-describedby="error-dialog-description"
                        PaperProps={{
                            sx: { borderRadius: "16px", padding: "16px" },
                        }}
                        fullWidth
                        maxWidth="sm"
                        >
                {/* Close Button */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box />
                    <IconButton size="small" onClick={()=>setErrorpopup(false)}>
                    <IconX />
                    </IconButton>
                </Box>

                {/* Error Icon & Title */}
                <DialogTitle id="error-dialog-title" align="center" sx={{ marginTop: -3 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                    <Box
                        sx={{
                        width: 60,
                        height: 60,
                        backgroundColor: "#fff3cd",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                        marginBottom: 2,
                        }}
                    >
                        <IconAlertTriangle size={32} color="#ff9800" />
                    </Box>
                    </Box>
                    <Typography variant="h6" fontWeight="bold">
                    Error 
                    </Typography>
                </DialogTitle>

                {/* Error Message */}
                <DialogContent>
                    <Typography id="error-dialog-description" align="center">
                    {errorMessage || "An unexpected error has occurred. Please try again."}
                    </Typography>
                </DialogContent>

                {/* Close Button */}
                <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
                    <Button
                    variant="contained"
                    color="error"
                    sx={{ backgroundColor: "#c63037", border: "none" }}
                    onClick={()=>setErrorpopup(false)}
                    >
                    Close
                    </Button>
                </DialogActions>
                </Dialog>
        </PageContainer>
    );
};

export default CardDetails;
